import type { ComponentPropsWithoutRef, ElementRef } from 'react'
import { forwardRef } from 'react'
import { TextInput, View } from 'react-native'

import { cn } from '@/ui/utils'
import { inputStyles } from './input.styles'

const Input = forwardRef<
	ElementRef<typeof TextInput>,
	ComponentPropsWithoutRef<typeof TextInput>
>(
	(
		{
			className,
			placeholderClassName,
			editable = true,
			placeholderTextColor = '#106A5C',
			value,
			onChangeText,
			...props
		},
		ref
	) => {
		const { container, input, placeholder } = inputStyles()

		return (
			<View className={cn(container(), className)}>
				<TextInput
					ref={ref}
					className={cn(input({ editable }))}
					placeholderClassName={cn(placeholder())}
					placeholderTextColor={placeholderTextColor}
					value={value}
					onChangeText={onChangeText}
					{...props}
				/>
			</View>
		)
	}
)

Input.displayName = 'Input'

export { Input }
